export const APPOINTMENT_WAITLIST_DRAFT_STORAGE_MAX_SERIALIZED_CHARACTERS =
  500_000;
export const APPOINTMENT_WAITLIST_RECEIPT_STORAGE_MAX_SERIALIZED_CHARACTERS =
  650_000;
export const APPOINTMENT_WAITLIST_SUBMISSION_ATTEMPT_STORAGE_MAX_SERIALIZED_CHARACTERS =
  900_000;
export const APPOINTMENT_WAITLIST_PENDING_TRANSITION_STORAGE_MAX_SERIALIZED_CHARACTERS =
  900_000;
export const APPOINTMENT_WAITLIST_TERMINAL_ATTEMPT_AGGREGATE_STORAGE_MAX_SERIALIZED_CHARACTERS =
  3_500_000;
export const SPECIALIST_LOCATION_GATEWAY_WAITLIST_TERMINAL_ORIGIN_STORAGE_MAX_SERIALIZED_CHARACTERS =
  1_500_000;
